import ContainerCRM from './components/container'
import TabelaListaCRM from './components/tabela'
import { ProviderServicesCRMContext } from './context/getCRM'

export type Evento = {
  id: number,
  descricao: string,
  atividade: number,
  inicio: string,
  fim: string,
  nome_cidade: string,
  nome_sede: string,
  sede: number,
  cidade: number,
  inscricao: boolean,
  ativo: boolean,
  whatsapp: string
}

export default function EventosCRM() {
  return (
    <>
      <ProviderServicesCRMContext>
        <div style={{ display: "flex", flex: 1, padding: 5 }}>
          <ContainerCRM />
        </div>
      </ProviderServicesCRMContext>
    </>
  )
}
